<template>
  <div>
    <div v-if="loading" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary" class="mr-2"></b-spinner>
      <span class="font-weight-bold">Loading leave data...</span>
    </div>

    <div v-else>
      <!-- Filter and Search Row -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <!-- Status Filter -->
        <div class="d-flex align-items-center">
          <b-form-select v-model="selectedStatus" @change="fetchFilteredLeaves" :options="statusOptions"
            placeholder="Select Status" label="text" track-by="value" class="w-auto mr-3"></b-form-select>
        </div>

        <!-- Search Box -->
        <div class="d-flex align-items-center" style="width: 40%;">
          <b-form-input
            v-model="searchQuery"
            placeholder="Search by name, email, or mobile..."
            class="w-100"
            @keyup.enter="fetchFilteredLeaves"
          ></b-form-input>
        </div>

      </div>

      <!-- Table -->
     
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>SI. No.</th>
              <th>Student</th>
              <th>Class</th>
              <th>Session</th>
              <th>Leave Type</th>
              <th>Event Name</th>
              <th>Reason</th>
              <th>Attachment</th>
              <th></th>
              <th v-if="selectedStatus == 'status_update' && mandatory_event_coordinator">Forwarded By & At</th>
              <th v-if="selectedStatus == 'status_update'">Recommended By & At</th>
              <th v-if="selectedStatus == 'status_update'">Verified By & At</th>
              <th v-if="selectedStatus == 'status_update'">Approved By & At</th>
              <th v-if="selectedStatus == 'status_update'">Rejected By & At</th>
              <th v-if="selectedStatus == 'status_update' || selectedStatus == 'rejected'">Reason For Reject</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(leave, sindex) in studentLeaveLists" :key="sindex">
              <td>{{ (currentPage - 1) * 15 + (sindex + 1) }}</td>
              <td>{{ leave.student.first_name }} {{ leave.student.last_name }} <br>
                <small>{{ leave.student.email }}<br>
                  {{ leave.student.mobile }}</small>
              </td>
              <td>{{ leave.usersubgroup.name }} - {{ leave.usersubgroup.usergroup.code }}</td>

              <td>
                <div v-if="studentLeaveSessions[leave.id]">
                  <div v-for="(sessionsOnDate, date) in groupByDate(studentLeaveSessions[leave.id])" :key="date">
                    {{ formatDate(date) }} -
                    <span v-for="(studentleave, index) in sessionsOnDate" :key="studentleave.id">
                      {{ studentleave.session.name }} ({{ studentleave.course.code }})
                      <span v-if="index < sessionsOnDate.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </td>

              <td>{{ leave.attendancetype ? leave.attendancetype.name : '' }}</td>
              
              <td>
                <span v-if="leave.attendancetype && leave.attendancetype.name == 'Duty Leave'">
                  {{ leave.event ? leave.event.name : 'Not Applicable' }}
                </span>
                <span v-if="leave.attendancetype && leave.attendancetype.name == 'Medical Leave'
                  && mandatory_event_coordinator">
                  Not Applicable
                </span>
              </td>

              <td>{{ leave.leave_reason }}</td>

              <td class="text-center">
                <a v-if="leave.files && leave.files.length > 0" :href="getFileUrl(leave.files[0])" target="_blank">
                  <i class="fas fa-paperclip text-gray-600" style="font-size: 12px;"></i>
                </a>
              </td>

              <td v-if="selectedStatus == 'status_update'">
                <template>

                  <!-- REJECTED ALWAYS HAS FIRST PRIORITY -->
                  <span v-if="firstRejectedBy(leave)"
                        class="text-danger font-weight-bold">
                    Rejected
                  </span>

                  <!-- FORWARDED BLOCK: check BEFORE showing other actions -->
                  <span v-else-if="isForwarded(leave)">
                    
                    <!-- If forwarded AND later approved -->
                    <span v-if="firstApprovedBy(leave)" 
                          class="text-success font-weight-bold">
                      Approved
                    </span>

                    <!-- If forwarded AND later recommended -->
                    <span v-else-if="firstRecommendedBy(leave)"
                          class="text-info font-weight-bold">
                      Recommended
                    </span>

                    <!-- If forwarded AND later verified -->
                    <span v-else-if="firstVerifiedBy(leave)"
                          class="text-primary font-weight-bold">
                      Verified
                    </span>

                    <!-- Forwarded but no other action -->
                    <span v-else class="text-purple font-weight-bold">
                      Forwarded
                    </span>
                  </span>

                  <!-- OLD LOGIC (NO FORWARD) -->
                  <span v-else-if="firstApprovedBy(leave)"
                        class="text-success font-weight-bold">
                    Approved
                  </span>

                  <span v-else-if="firstRecommendedBy(leave)"
                        class="text-info font-weight-bold">
                    Recommended
                  </span>

                  <span v-else-if="firstVerifiedBy(leave)"
                        class="text-primary font-weight-bold">
                    Verified
                  </span>

                  <span v-else class="text-warning font-weight-bold">
                    Pending
                  </span>

                </template>
              </td>

               <td v-else>
                <template v-if="showActionButtons(leave)">
                  <button @click="handleAction(leave)" class="btn btn-success">
                    {{ actionLabel(leave) }}
                  </button>
                  <button @click="openRejectModal(leave.id)" class="btn btn-danger">
                    Reject
                  </button>
                </template>
                <template v-else>
                  <span v-if="leave.approvers.some(a => a.action_type === 'reject' && a.action_by)"
                    class="text-danger font-weight-bold">Rejected</span>
                  <span v-else-if="leave.approvers && firstApprovedBy(leave)"
                    class="text-success font-weight-bold">Approved</span>
                  <span v-else-if="leave.approvers && firstRecommendedBy(leave)"
                    class="text-info font-weight-bold">Recommended</span>
                  <span v-else-if="leave.approvers && firstVerifiedBy(leave)"
                    class="text-primary font-weight-bold">Verified</span>
                  <span v-else class="text-warning font-weight-bold">Pending</span>
                </template>
              </td>

              <td v-if="selectedStatus == 'status_update' && mandatory_event_coordinator">
                <template v-if="isForwarded(leave)">
                  <template v-if="isForwarded(leave).action_by_user">
                    {{ isForwarded(leave).action_by_user.first_name }}
                    {{ isForwarded(leave).action_by_user.last_name }}<br />
                  </template>
                  {{ formatDate(isForwarded(leave).action_at) }}
                </template>
              </td>


              <td v-if="selectedStatus == 'status_update'">
                <template v-if="firstRecommendedBy(leave)">
                  <template v-if="firstRecommendedBy(leave).action_by_user">
                    {{ firstRecommendedBy(leave).action_by_user.first_name }}
                    {{ firstRecommendedBy(leave).action_by_user.last_name }}<br />
                  </template>
                  {{ formatDate(firstRecommendedBy(leave).action_at) }}
                </template>
              </td>

              <td v-if="selectedStatus == 'status_update'">
                <template v-if="firstVerifiedBy(leave)">
                  <template v-if="firstVerifiedBy(leave).action_by_user">
                    {{ firstVerifiedBy(leave).action_by_user.first_name }}
                    {{ firstVerifiedBy(leave).action_by_user.last_name }}<br />
                  </template>
                  {{ formatDate(firstVerifiedBy(leave).action_at) }}
                </template>
              </td>

              <td v-if="selectedStatus == 'status_update'">
                <template v-if="firstApprovedBy(leave)">
                  <template v-if="firstApprovedBy(leave).action_by_user">
                    {{ firstApprovedBy(leave).action_by_user.first_name }}
                    {{ firstApprovedBy(leave).action_by_user.last_name }}<br />
                  </template>
                  {{ formatDate(firstApprovedBy(leave).action_at) }}
                </template>
              </td>

              <td v-if="selectedStatus == 'status_update'">
                <template v-if="firstRejectedBy(leave)">
                  <template v-if="firstRejectedBy(leave).action_by_user">
                    {{ firstRejectedBy(leave).action_by_user.first_name }}
                    {{ firstRejectedBy(leave).action_by_user.last_name }}<br />
                  </template>
                  {{ formatDate(firstRejectedBy(leave).action_at) }}
                </template>
              </td>

              <td v-if="selectedStatus == 'status_update' || selectedStatus == 'rejected'">{{ leave.reject_reason }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="d-flex justify-content-center mt-4" v-if="lastPage > 1">
          <b-pagination v-model="currentPage" :total-rows="lastPage * 15" :per-page="15" align="center"
            @change="fetchFilteredLeaves"></b-pagination>
        </div>
      </div>
   

    <!-- Reject Modal -->
    <b-modal id="rejectModal" title="Enter Rejection Reason" @ok="submitRejection">
      <label>Reason</label>
      <b-form-group>
        <b-form-radio-group v-model="reasonType">
          <b-form-radio value="with">With Reason</b-form-radio>
          <b-form-radio value="without">Without Reason</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-input v-if="reasonType === 'with'" v-model="rejectReason" type="text"></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import acl from "../../../../authorization/acl.js";

export default {
  data() {
    return {
      mandatory_event_coordinator: false,
      searchQuery: "",
      loading: false,
      currentPage: 1,
      lastPage: 1,
      studentLeaveLists: [],
      studentLeaveSessions: [],
      adminstudentLeaveIds: [],
      hodstudentLeaveIds: [],
      advisorstudentLeaveIds: [],
      selectedStatus: "pending",
      rejectReason: "",
      selectedLeaveId: null,
      reasonType: "with",
      student_leave_approval_level: "1",
      cloudStorageRoot: "",
      instituitionAdmin: false,
      mainGroupAdmin: false,
      userGroupAdmin: false,
      subgroupAdmin: false,
      statusOptions: [
        { value: "pending", text: "Pending Approval" },
        { value: "approved", text: "Approval Completed" },
        { value: "rejected", text: "Rejected" },
        { value: "status_update", text: "Status Update" },
      ],
    };
  },

  async created() {
    this.instituitionAdmin = await acl.isUserGranted("editInstituitionSettings");
    this.mainGroupAdmin = await acl.isUserGranted("mainGroupAdmin");
    this.userGroupAdmin = await acl.isUserGranted("groupAdmin");
    this.subgroupAdmin = await acl.isUserGranted("subgroupAdmin");
    await this.getStudentLeaveSettings();
    await this.fetchFilteredLeaves();
    this.cloudStorageRoot = this.$store.getters.getAPIKey.userAttachments;
  },

  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("en-GB");
    },

    getFileUrl(file) {
      return this.cloudStorageRoot + file.file_path + file.file_name;
    },

    groupByDate(sessions) {
      const grouped = {};
      sessions.forEach((session) => {
        if (!grouped[session.date]) grouped[session.date] = [];
        grouped[session.date].push(session);
      });
      return grouped;
    },

    async getStudentLeaveSettings() {
      this.fetchData = true;
      const settingKey = "student_leave_approval_level";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);

      await axios
        .get(url)
        .then((response) => {
          this.student_leave_approval_level = response.data ? response.data : '1';
        })
        .catch(() => {
          this.$toast.error("Failed to load student leave settings", {
            top: "top",
            duration: 6000,
          });
        });

      /* ---- mandatory_event_coordinator Setting ---- */
      const settingKey2 = "mandatory_event_coordinator";
      const url2 = mainUrl.replace("setting_key", settingKey2);

      await axios.get(url2)
        .then((response) => {
          this.mandatory_event_coordinator = response.data == 1 ? true : false;
        })
        .catch(() => {});

      this.fetchData = false; 
    },

    async fetchFilteredLeaves(page = 1) {
       this.loading = true;
      try {
        const response = await axios.get(
          `${this.$store.getters.getAPIKey.mainAPI}/studentleaves?status=${this.selectedStatus}&page=${page}&per_page=15&search=${this.searchQuery}`
        );

        const data = response.data.student_leaves;
        this.studentLeaveLists = Array.isArray(data) ? data : data.data;
        this.studentLeaveSessions = response.data.student_leave_sessions || {};
        this.adminstudentLeaveIds = response.data.admin || [];
        this.hodstudentLeaveIds = response.data.hod || [];
        this.advisorstudentLeaveIds = response.data.advisor || [];
        this.currentPage = data.current_page || 1;
        this.lastPage = data.last_page || 1;
      } catch (error) {
        console.error("Error fetching filtered student leaves:", error);
      }
       finally {
        this.loading = false;
      }
    },

    isForwarded(leave) {
      return leave.approvers.find(a => a.action_type === "forward" && a.action_by);
    },

    firstApprovedBy(leave) {
      return leave.approvers.find(a => a.action_type === "approve" && a.action_by);
    },

    firstRecommendedBy(leave) {
      return leave.approvers.find(a => a.action_type === "recommend" && a.action_by);
    },

    firstVerifiedBy(leave) {
      return leave.approvers.find(a => a.action_type === "verify" && a.action_by);
    },

    firstRejectedBy(leave) {
      return leave.approvers.find(a => a.action_type === "reject" && a.action_by);
    },


    showActionButtons(leave) {
      const approver = this.getApproverMap(leave.approvers);

      if (approver.rejected_by) return false;

      // EVENT RULE:
      // If event exists and NOT forwarded → show Forward + Reject
      if (leave.event_id !== null && !this.isForwarded(leave)) {
        return true; // forward + reject
      }

      // If event exists AND forwarded → follow OLD LOGIC
      // So do NOT "return false" here — continue below

      // OLD RULES
      return (
        (leave.leave_approval_type === "1" &&
          !approver.approved_by &&
          this.subgroupAdmin &&
          this.advisorstudentLeaveIds.includes(leave.id)) ||

        (leave.leave_approval_type === "2" &&
          !approver.recommended_by &&
          this.subgroupAdmin &&
          this.advisorstudentLeaveIds.includes(leave.id)) ||

        (leave.leave_approval_type === "2" &&
          approver.recommended_by &&
          !approver.approved_by &&
          this.mainGroupAdmin &&
          this.hodstudentLeaveIds.includes(leave.id)) ||

        (leave.leave_approval_type === "3" &&
          !approver.verified_by &&
          this.subgroupAdmin &&
          this.advisorstudentLeaveIds.includes(leave.id)) ||

        (leave.leave_approval_type === "3" &&
          approver.verified_by &&
          !approver.recommended_by &&
          this.mainGroupAdmin &&
          this.hodstudentLeaveIds.includes(leave.id)) ||

        (leave.leave_approval_type === "3" &&
          approver.recommended_by &&
          !approver.approved_by &&
          this.instituitionAdmin)
      );
    },

    getApproverMap(approvers) {
      const map = {
        verified_by: null,
        recommended_by: null,
        approved_by: null,
        rejected_by: null,
      };
      if (!Array.isArray(approvers)) return map;

      for (const a of approvers) {
        if (a.action_type === "verify") map.verified_by = a.action_by_user;
        if (a.action_type === "recommend") map.recommended_by = a.action_by_user;
        if (a.action_type === "approve") map.approved_by = a.action_by_user;
        if (a.action_type === "reject") map.rejected_by = a.action_by_user;
      }
      return map;
    },

    handleAction(leave) {
      const approver = this.getApproverMap(leave.approvers);
      if (approver.rejected_by) return;

      // EVENT RULE:
      // If event exists AND NOT forwarded → forward only
      if (leave.event_id !== null && !this.isForwarded(leave)) {
        this.updateLeaveStatus(leave.id, "forward");
        return;
      }

      // If event exists AND forwarded
      if (leave.leave_approval_type === "1" && !approver.approved_by)
        this.updateLeaveStatus(leave.id, "approve");
      else if (leave.leave_approval_type === "2") {
        if (!approver.recommended_by) this.updateLeaveStatus(leave.id, "recommend");
        else if (!approver.approved_by) this.updateLeaveStatus(leave.id, "approve");
      } else if (leave.leave_approval_type === "3") {
        if (!approver.verified_by) this.updateLeaveStatus(leave.id, "verify");
        else if (!approver.recommended_by) this.updateLeaveStatus(leave.id, "recommend");
        else if (!approver.approved_by) this.updateLeaveStatus(leave.id, "approve");
      }
    },

    actionLabel(leave) {
      // Event logic
      if (leave.event_id !== null && !this.isForwarded(leave))
        return "Forward";

      if (this.isForwarded(leave))
        return this.actionLabelAfterForwardLogic(leave);

      return this.actionLabelAfterForwardLogic(leave);
    },

    actionLabelAfterForwardLogic(leave) {
      const approver = this.getApproverMap(leave.approvers);
      if (approver.rejected_by) return "Rejected";
      if (leave.leave_approval_type === "1" && !approver.approved_by) return "Approve";
      if (leave.leave_approval_type === "2") {
        if (!approver.recommended_by) return "Recommend";
        if (approver.recommended_by && !approver.approved_by) return "Approve";
      }
      if (leave.leave_approval_type === "3") {
        if (!approver.verified_by) return "Verify";
        if (approver.verified_by && !approver.recommended_by) return "Recommend";
        if (approver.recommended_by && !approver.approved_by) return "Approve";
      }
      return "";
    },

    openRejectModal(leaveId) {
      this.selectedLeaveId = leaveId;
      this.rejectReason = "";
      this.$bvModal.show("rejectModal");
    },

    async submitRejection() {
      await this.updateLeaveStatus(this.selectedLeaveId, "reject", this.rejectReason);
      this.$bvModal.hide("rejectModal");
    },


    async updateLeaveStatus(leaveId, action, rejectReason = null) {
      try {
        await axios.post(
          `${this.$store.getters.getAPIKey.mainAPI}/studentleaves/${leaveId}/update-status`,
          { action, reject_reason: rejectReason }
        );

        this.$toast.success("Leave updated successfully", { position: "top", duration: 3000 });
        this.studentLeaveLists = this.studentLeaveLists.filter(l => l.id !== leaveId);

      } catch (error) {
        console.error("Error updating leave:", error);
        this.$toast.error("Failed to update leave", { position: "top", duration: 3000 });
      }
    },

  },
};
</script>